import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } })
      .then(({ data }) => {
        setProducts(
          Array.isArray(data)
            ? data
            : Array.isArray(data?.products)
              ? data.products
              : []
        );
      })
      .catch((error) => {
        console.error("Failed to load featured products:", error);
        setProducts([]);
      });
  }, []);

  return (
    <section className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="featured-section">
      <Reveal className="text-center mb-12">
        <h2 className="font-serif text-3xl lg:text-4xl text-charcoal">Featured Collection</h2>
        <div className="w-16 h-px bg-gold mx-auto mt-5" />
      </Reveal>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {products.map((p, i) => (
          <Reveal key={p.id} delay={(i % 6) * 0.06}>
            <ProductCard product={p} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};